import { ApiService, type ApiRequestConfig } from "./api.service";
import type { TWorkspaceTeamSetupAreas, TWorkspaceTeamSetupAreasUpdate } from "@/types/workspace";

/** Which team-owned setup areas Team Leads may manage (NG-3024, spec 6.2). Any
 *  member may read it; changing it needs `workspace.edit`. */
export class WorkspaceTeamSetupAreasService extends ApiService {
  async getTeamSetupAreas(
    slug: string,
    config?: ApiRequestConfig,
  ): Promise<TWorkspaceTeamSetupAreas> {
    return this.get(`/api/workspaces/${slug}/team-setup-areas/`, config);
  }

  async updateTeamSetupAreas(
    slug: string,
    data: TWorkspaceTeamSetupAreasUpdate,
  ): Promise<TWorkspaceTeamSetupAreas> {
    return this.patch(`/api/workspaces/${slug}/team-setup-areas/`, data);
  }
}
